export default __webpack_public_path__ + "static/media/SLE.9fd54ecf.svg";